import {
  CalloutContent,
  CalloutIcon,
  CalloutRoot,
} from '@/shared/ui/Callout/styles'
import type { ReactNode } from 'react'

export type CalloutProps = {
  icon?: ReactNode
  children: ReactNode
  variant?: 'info'
}

export function Callout({ icon, children, variant = 'info' }: CalloutProps) {
  return (
    <CalloutRoot variant={variant}>
      {icon && <CalloutIcon>{icon}</CalloutIcon>}
      <CalloutContent>{children}</CalloutContent>
    </CalloutRoot>
  )
}
